module.exports = __webpack_public_path__ + "img/file-manager.dd7e16f2.png";